import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateCoverageCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type CoverageState = void;

export const COVERAGE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CoverageState>>,
): ConditionType<CoverageState, Condition.Coverage> => ({
  name: CONDITION_NAMES[Condition.COVERAGE],
  description() {
    return t("Has Redo return coverage");
  },
  Details(props: ConditionTypeDetailsProps<CoverageState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.COVERAGE };
  },
  valid() {
    return validateCoverageCondition({}).valid;
  },
});
